/* 0511ER – E-Mail-Formulare (Early Access, Drop List, PLZ-Wunsch).
   Normales Absenden über Shopify, damit der Spam-Schutz (hCaptcha) sauber läuft. Kein unsichtbarer Rahmen mehr:
   der verbrauchte das Captcha-Token und führte zu "Invalid CAPTCHA token".
   Nach dem Absenden lädt die Seite neu und springt zum Formular (Bestätigung oder Fehler).
   Early Access meldet zusätzlich das Ereignis drop_signup (early_access: true).
   Dazu eine Stilkorrektur: Die Bestätigung im dunklen Drop-Block bekam aus base.css einen weißen Hintergrund
   (weiß auf weiß). Hier auf transparent gesetzt. */
(function () {
  var IDS = ['early-access-form', 'drop-liste-form', 'plz-wunsch-form'];

  try {
    var stil = document.createElement('style');
    stil.textContent = '.dp .form-status{background:transparent;color:var(--on-dark)}';
    document.head.appendChild(stil);
  } catch (x) {}

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || IDS.indexOf(form.id) === -1) return;
    var knopf = form.querySelector('[type=submit]');
    if (knopf) knopf.setAttribute('aria-busy', 'true');
    if (form.id === 'early-access-form') {
      try { Shopify.analytics.publish('drop_signup', { seite: location.pathname, early_access: true }); } catch (x) {}
    }
  }, true);
})();
